// @ts-ignore
import { createConsumer, Consumer } from "@rails/actioncable";

const getCableUrl = (baseUrl: string, token: string): string => {
  const host = baseUrl.replace(/^https?:\/\//, "");
  // Use startsWith (not includes) so an http:// URL with "https" elsewhere in the
  // path can't be mis-detected as secure.
  const protocol = baseUrl.startsWith("https:") ? "wss:" : "ws:";
  // encodeURIComponent the token so any non-base64url payload (or a future token
  // format with reserved query characters) doesn't break the query string.
  return `${protocol}//${host}/cable?token=${encodeURIComponent(token)}`;
};

export const createCableConsumer = (baseUrl: string, token: string): Consumer => {
  return createConsumer(getCableUrl(baseUrl, token));
};
